import styled from "@emotion/styled";
import { useRealEstateDetailContext } from "../../context/realestate-details.context";
import { Alert } from "@mui/material";
import { useEffect } from "react";
import SimpleCard from "@/src-refactor/modules/shared/components/SimpleCard";
import { IconFlagFilled } from "@tabler/icons-react";
import useUserHasPermission from "@/shared/hooks/use-useris.hook";

export interface IAgenciesDetailResponse {
  agencyId: number;
  name: string;
  phone: number;
  email: string;
  picture: string;
  brokers: Broker[];
}

export interface Broker {
  broker: Broker[];
}

const WarningCard = () => {
  const {
    PROPERTY_DETAIL: { principalData }
  } = useRealEstateDetailContext();
  const { USER_ROLE } = useUserHasPermission();

  useEffect(() => {}, []);

  if (!principalData.has_important_alert) {
    return <></>;
  }
  if (!USER_ROLE.SUPER_ADMIN) {
    return <></>;
  }
  return (
    <SimpleCard showBg={false} title="Avisos">
      <Content>
        <Alert
          icon={
            <IconFlagFilled
              style={{
                fill: "#dc1d2d",
                width: "18px",
                height: "18px"
              }}
            />
          }
          severity="error"
        >
          {principalData.important_alert_message}
        </Alert>
      </Content>
    </SimpleCard>
  );
};

export default WarningCard;

const Content = styled.div`
  width: 100%;
`;
